import { AssetClassLandModel } from "src/app/core/comparable/_models/asset-class-land.model";
import { convertSize, mapUnitOfAreaMeasurement } from "../../size";

export function landComparableSizeInMetric(assetClass: AssetClassLandModel) {
  if (!assetClass.boundary_type_id || assetClass.boundary_type_id == 1) {
    if (assetClass.land_area_components.length === 0) return 0;
    return assetClass.land_area_components.reduce(
      (acc, item) => {
        const unitOfAreaMeasurement = mapUnitOfAreaMeasurement(item.unit_area_measurement_id)
        return acc + convertSize(item.surface, unitOfAreaMeasurement, 'sqm') 
      },
      0
    )
  }
  if (assetClass.points.length === 0) return 0;
  return google.maps.geometry.spherical.computeArea(
    assetClass.points.map(p => new google.maps.LatLng(Number(p.lat), Number(p.lng)))
  )
}